import React, { useEffect, useState } from 'react';
import { translate } from '../../services/translate';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { licensePlateRecognitionService } from '../../services/central-api/license-plate-recognition';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';

type Props = {
    zIndex: number;
    showLabel?: boolean;
    required?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function UnitNamesDropdown({ value, setValue, zIndex, showLabel, form, fieldName, required }: Props) {
    const [units, setUnits] = useState<{ label: string; value: number; }[]>([]);

    async function getUnitNames() {
        try {
            const response = await licensePlateRecognitionService.getUnitNames();
            setUnits(response.map((unitName) => {
                return {
                    value: unitName.id,
                    label: unitName.name
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getUnitNames();
    }, []);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={showLabel ? translate('teams') : undefined}
            placeholder={translate('teams')}
            items={units}
            zIndex={zIndex}
            fieldName={fieldName}
            required={required}
            form={form}
            multiple={true}
            mode='BADGE'
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={showLabel ? translate('teams') : undefined}
                placeholder={translate('teams')}
                items={units}
                multiple={true}
                required={required}
                mode='BADGE'
                setValue={setValue}
                value={value}
                zIndex={zIndex}
            />
        );
    }
}

export default UnitNamesDropdown;
